import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';

@Injectable()
export class CancelTaskFileReviewService {
  constructor(private httpClient: HttpClient, private configService: ConfigService) {}

  public cancel(id: string): Observable<any> {
    const url: string = `${this.configService.config.rest.apiV2Url}/task-files/${id}/cancel-review`;

    return this.httpClient.post(url, {})
    .pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
